import styled from 'styled-components'
import Card from '@material-ui/core/Card'

export const StyledCard = styled(Card)`
  box-shadow: none;
  width: 100%;
`
